import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./main.css";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "./custom.scss";

import FormBuilder from "../../Breeze.FormBuilder.Frontend/plugins/formBuilder";

import mixins from "./plugins/mixins";

import VueSanitize from "vue-sanitize";
import { initializeToken } from "./helpers/session";

import VueSignaturePad from "vue-signature-pad";

import coreServer from "./server/core";

import "fontawesome-4.7";
import "./assets/fa6/css/all.css";

import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import InputFacade from "vue-input-facade";

import Directives from "./plugins/directives";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(InputFacade);

Vue.use(FormBuilder);

Vue.use(mixins);

Vue.use(Directives);

import sanitizeOptions from "./config/sanitize";
Vue.use(VueSanitize, sanitizeOptions);

Vue.use(VueSignaturePad);

Vue.component("v-select", vSelect);
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

initializeToken().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
    created() {
      coreServer.setupInterceptors(store);
      //store.dispatch(`layout/fetchInitialData`);
    }
  }).$mount("#app");
});
